<app-img-header
  title="Productos"
  alt="Daimler Truck"
  subTitle=""
  image="/assets/images/cotizador/intro.jpg"
></app-img-header>
@if (isLoading) {
  <app-preloader></app-preloader>
}
<main class="main" id="product">
  <div id="detail">
    <div class="pageWidth">
      <div class="dataAndPhoto">
        <div class="data">
          <div class="wrapperG4">
            <div class="controlWrapper nombreProducto">
              <label for="">Nombre del producto</label>
              <span class="value">{{ form.get('name')?.value }}</span>
            </div>

            <div class="controlWrapper tipoProducto">
              <label for="">Tipo de producto</label>
              <span class="value">{{ form.get('modelType')?.value }}</span>
            </div>

            @if (this.brand && this.subBrand) {
              <div class="controlWrapper">
                <label for="">Marca</label>
                <span class="value">{{ this.brand.brand }}</span>
              </div>

              <div class="controlWrapper">
                <label for="">Submarca</label>
                <span class="value">{{ this.subBrand.subBrand }}</span>
              </div>
            }
            <div class="controlWrapper">
              <label for="">Condición</label>
              <span class="value">{{ form.get('classification')?.value ? 'Nuevo' : 'Seminuevo' }}</span>
            </div>

            <div class="controlWrapper">
              <label for="">Año</label>
              <span class="value">{{ form.get('year')?.value }}</span>
            </div>

            <div class="controlWrapper">
              <label for="">Precio de venta</label>
              <span class="value">{{ form.get('price')?.value }}</span>
            </div>

            <div class="controlWrapper">
              <label for="">Precio máximo</label>
              <span class="value">{{ form.get('maxPrice')?.value }}</span>
            </div>

            <div class="controlWrapper">
              <label for="">Moneda</label>
              <span class="value">{{ form.get('currency')?.value }}</span>
            </div>

            <div class="controlWrapper">
              <label for="">ID para seguro</label>
              <span class="value">{{ form.get('modelCode')?.value }}</span>
            </div>

            <label class="switch gapTop">
              <input type="checkbox" [checked]="form.get('enabled')?.value" disabled />
              <span class="knob"></span>
              <span class="base"></span>
              <span class="description">Estado activo</span>
            </label>
          </div>
        </div>
        <!-- Imagen -->
        <div class="photo">
          @if (productImg() !== '') {
            <picture>
              <img
                src="{{ productImg() }}"
                width="218"
                height="132"
                alt="Subrand model image"
                decoding="async"
                loading="lazy"
              />
            </picture>
          } @else {
            <div class="noImage">
              <span>Sin imagen</span>
            </div>
          }
        </div>
      </div>

      <div id="valorResidual">
        <h2>Valor residual</h2>
        <div class="tableWrapper">
          <div *ngIf="residualModelValuesSorted.length === 0" class="noData">No hay información disponible</div>
          @if (residualModelValuesSorted.length > 0) {
            <div class="customTable valorResidual readOnly">
              <div class="header">
                <div class="cell periodo">Período</div>
                <div class="cell daimler">Garantía Daimler</div>
                <div class="cell terceros">Garantía Terceros</div>
              </div>
              <div class="row" *ngFor="let value of residualModelValuesSorted">
                <div class="cell periodo">{{ value.term }} meses</div>
                <div class="cell daimler">
                  <span>{{ value.daimlerRate }}%</span>
                  <span
                    >{{ value?.daimlerFixedAmount | currency: '' : '' }}
                    {{ form.get('currency')?.value || 'MXN' }}</span
                  >
                </div>
                <div class="cell terceros">
                  {{ value.externalsMinRate }}% <span class="min">Min</span> {{ value.externalsMaxRate }}%
                  <span>Max</span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="actions">
        <div class="wrapper">
          <button (click)="back()" type="button" class="secondary">Volver</button>
        </div>
      </div>
    </div>
  </div>
</main>
